const SESSION_KEY    = 'rhHire';
const MINUS_SELECTOR = '.rh-acc-minus[data-key="';

const initStepAccessories = () => {
  const stepEl = document.querySelector('#rh-step-3:not([data-rh-init])');
  if (!stepEl) return;
  stepEl.dataset.rhInit = 'true';

  const accessories = {};

  document.querySelectorAll('.rh-acc-plus').forEach(function (btn) {
    const key = btn.dataset.key;
    if (!(key in accessories)) accessories[key] = 0;
  });

  const saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
  if (saved.accessories) {
    Object.keys(saved.accessories).forEach(function (k) {
      if (k in accessories) accessories[k] = saved.accessories[k];
    });
  }

  function renderAll() {
    Object.keys(accessories).forEach(function (key) {
      const countEl  = document.getElementById('rh-acc-count-' + key);
      const minusBtn = document.querySelector(MINUS_SELECTOR + key + '"]');
      if (countEl)  countEl.value    = accessories[key];
      if (minusBtn) minusBtn.disabled = accessories[key] <= 0;
    });
  }

  document.querySelectorAll('.rh-acc-plus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      accessories[btn.dataset.key]++;
      renderAll();
    });
  });

  document.querySelectorAll('.rh-acc-minus').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (accessories[btn.dataset.key] > 0) {
        accessories[btn.dataset.key]--;
        renderAll();
      }
    });
  });

  document.querySelectorAll('.rh-acc-input').forEach(function (input) {
    const key = input.dataset.key;
    input.addEventListener('input', function () {
      const parsed = parseInt(input.value, 10);
      if (!isNaN(parsed) && parsed >= 0) {
        accessories[key] = parsed;
        const minusBtn = document.querySelector(MINUS_SELECTOR + key + '"]');
        if (minusBtn) minusBtn.disabled = parsed <= 0;
      }
    });
    input.addEventListener('blur', function () {
      if (input.value === '' || isNaN(parseInt(input.value, 10))) {
        accessories[key] = 0;
      }
      input.value = accessories[key];
      const minusBtn = document.querySelector(MINUS_SELECTOR + key + '"]');
      if (minusBtn) minusBtn.disabled = accessories[key] <= 0;
    });
  });

  function goBack() {
    const url = new URL(window.location.href);
    url.searchParams.set('step', '2');
    window.location.href = url.toString();
  }

  function goNext() {
    const hire = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    hire.accessories = accessories;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(hire));
    const url = new URL(window.location.href);
    url.searchParams.set('step', '4');
    window.location.href = url.toString();
  }

  document.getElementById('rh-back-3').addEventListener('click', goBack);
  document.getElementById('rh-next-3').addEventListener('click', goNext);
  document.getElementById('rh-next-3-arrow').addEventListener('click', goNext);

  renderAll();
};

export default initStepAccessories;
